import styled from 'styled-components'
import { Box } from '@pancakeswap/uikit'

const Row = styled(Box)<{ children?: import('react').ReactNode; width?: string
  align?: string
  justify?: string
  padding?: string
  border?: string
  borderRadius?: string }>`
  width: ${({ width }) => width ?? '100%'};
  display: flex;
  align-items: ${({ align }) => align ?? 'center'};
  justify-content: ${({ justify }) => justify ?? 'flex-start'};
  padding: ${({ padding }) => padding ?? '0'};
  border: ${({ border }) => border};
  border-radius: ${({ borderRadius }) => borderRadius};
`

export const RowBetween = styled(Row)`
  justify-content: space-between;
`

export const RowFlat = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  display: flex;
  align-items: flex-end;
`

export const AutoRow = styled(Row)<{ children?: import('react').ReactNode; gap?: string; justify?: string }>`
  flex-wrap: wrap;
  margin: ${({ gap }) => gap && `-${gap}`};
  justify-content: ${({ justify }) => justify};

  & > * {
    margin: ${({ gap }) => gap} !important;
  }
`

export const RowFixed = styled(Row)<{ children?: import('react').ReactNode; gap?: string; justify?: string }>`
  width: fit-content;
  margin: ${({ gap }) => gap && `-${gap}`};

  & > * {
    margin: ${({ gap }) => gap} !important;
  }
`

export default Row
